// extracted by mini-css-extract-plugin
export var equalColumn = "_ic-0";